// extracted by mini-css-extract-plugin
module.exports =  {"container":"_6c97079b1b--container--k5EGu","item":"_6c97079b1b--item--SjU8t","title":"_6c97079b1b--title--p2b_V"};